export type AiNodeActionType =
  | "GREETING"
  | "SAY_MESSAGE"
  | "ASK_QUESTION"
  | "CONDITION"
  | "TOOL_CALL"
  | "TRANSFER"
  | "SET_OUTCOME"
  | "END_CONVERSATION";

export interface AiConversationNodeData extends Record<string, unknown> {
  actionType: AiNodeActionType;
  label: string;
  message?: string;
  questionPrompt?: string;
  variableName?: string;
  conditionField?: string;
  conditionOperator?: string;
  conditionValue?: string;
  toolName?: string;
  toolParameters?: string;
  transferTarget?: string;
  outcomeName?: string;
  onEdit?: () => void;
  onDelete?: () => void;
}

export const AI_NODE_ACTION_TYPES: { value: AiNodeActionType; label: string }[] = [
  { value: "GREETING", label: "Greeting" },
  { value: "SAY_MESSAGE", label: "Say Message" },
  { value: "ASK_QUESTION", label: "Ask Question" },
  { value: "CONDITION", label: "Condition" },
  { value: "TOOL_CALL", label: "Tool Call" },
  { value: "TRANSFER", label: "Transfer" },
  { value: "SET_OUTCOME", label: "Set Outcome" },
  { value: "END_CONVERSATION", label: "End Conversation" },
];

export const AVAILABLE_TOOLS = [
  { value: "check_availability", label: "Check Availability" },
  { value: "book_appointment", label: "Book Appointment" },
  { value: "lookup_property", label: "Lookup Property" },
  { value: "lookup_contact", label: "Lookup Contact" },
  { value: "create_lead", label: "Create Lead" },
  { value: "send_sms", label: "Send SMS" },
  { value: "custom", label: "Custom Tool" },
];

export const CONDITION_OPERATORS = [
  { value: "equals", label: "Equals" },
  { value: "not_equals", label: "Not Equals" },
  { value: "contains", label: "Contains" },
  { value: "not_contains", label: "Does Not Contain" },
  { value: "is_empty", label: "Is Empty" },
  { value: "is_not_empty", label: "Is Not Empty" },
];
